import { render } from "./ContentSection.vue?vue&type=template&id=9774910a&ts=true"
import script from "./ContentSection.vue?vue&type=script&lang=ts"
export * from "./ContentSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__